import { render, staticRenderFns } from "./RflmChildrenInfo.vue?vue&type=template&id=4deaf720&scoped=true"
import script from "./RflmChildrenInfo.vue?vue&type=script&lang=ts"
export * from "./RflmChildrenInfo.vue?vue&type=script&lang=ts"
import style0 from "./RflmChildrenInfo.vue?vue&type=style&index=0&id=4deaf720&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deaf720",
  null
  
)

export default component.exports